import { render, staticRenderFns } from "./ManageRoleEdit.vue?vue&type=template&id=681e39f2"
import script from "./ManageRoleEdit.vue?vue&type=script&lang=js"
export * from "./ManageRoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports